import React, { Component } from 'react';
import contrast from 'get-contrast';
import leftPad from 'left-pad';
import logo from './logo.svg';
import './App.css';
import RandomSiteBase from './RandomSiteBase.js'
import RandomBlogSite from './RandomBlogSite.js'
import RandomNewsSite from './RandomNewsSite.js'
import fontList from './fontlist.js'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerFont: this.getRandomFont(),
      bodyFont: this.getRandomFont(),
      baseColor: this.getRandomGrey(),
      accentColor: this.getRandomColor(),
      backgroundColor: this.getRandomGrey(),
      image: this.getImage(),
      palette: [],
      impsum: ''

    }

    this.getImage = this.getImage.bind(this);
    this.getRandomColor = this.getRandomColor.bind(this);
    this.getRandomFont = this.getRandomFont.bind(this);
  }

  componentDidMount() {
    this.randomiseThings()
  }

  getImage() {
    return 'https://source.unsplash.com/random/1200x800?t=' + new Date().getTime();
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getRandomGrey() {
    var value = Math.random() * 0xFF | 0;
    var grayscale = (value << 16) | (value << 8) | value;
    var color = '#' + leftPad(grayscale.toString(16), 6, 0);
    return color;
  }


  getRandomFont() {
    return fontList[Math.floor(Math.random() * fontList.length)];
  }


  handleKeyDown = e => {
    if (e.code === 'Space') {
      e.preventDefault();
      this.randomiseThings();
    }
  }

  randomiseThings() {
    const baseColor = this.getRandomGrey();
    const bgColor = this.getRandomGrey();
    let accentColor = this.getRandomColor();
    console.log(baseColor + ' ' + bgColor)
    console.log(contrast.isAccessible(baseColor, bgColor))
    if (contrast.isAccessible(baseColor, bgColor)) {
      this.setState({ headerFont: this.getRandomFont() });
      this.setState({ bodyFont: this.getRandomFont() });
      this.setState({ baseColor: baseColor })
      this.setState({ backgroundColor: bgColor })
      while (!contrast.isAccessible(bgColor, accentColor)) {
        accentColor = this.getRandomColor();
      }
      this.setState({ accentColor: accentColor });
      this.setState({ image: this.getImage() });
    } else {
      this.randomiseThings()
    }
  }

  componentWillMount() {
    document.addEventListener("keypress", this.handleKeyDown.bind(this))
  }

  render() {
    return (
      <div className="">
        {Math.random() >= 0.66
          ? <RandomSiteBase
            bodyFont={this.state.bodyFont}
            headerFont={this.state.headerFont}
            baseColor={this.state.baseColor}
            backgroundColor={this.state.backgroundColor}
            accentColor={this.state.accentColor}
            imageUrl={this.state.image}
          />
          :

          Math.random() >= 0.5
            ? <RandomBlogSite
              bodyFont={this.state.bodyFont}
              headerFont={this.state.headerFont}
              baseColor={this.state.baseColor}
              backgroundColor={this.state.backgroundColor}
              accentColor={this.state.accentColor}
              imageUrl={this.state.image}
            />
            : <RandomNewsSite
              bodyFont={this.state.bodyFont}
              headerFont={this.state.headerFont}
              baseColor={this.state.baseColor}
              backgroundColor={this.state.backgroundColor}
              accentColor={this.state.accentColor}
              imageUrl={this.state.image}
            />



        }

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js